
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lp/black-friday-cyber-monday",
      function () {
        return require("private-next-pages/lp/black-friday-cyber-monday.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lp/black-friday-cyber-monday"])
      });
    }
  